<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: #00cc00">Please Wait</p>
    </ngx-spinner> -->
<div class="container" *ngIf="isLoading">
    <div class="con_outerdiv">
        <div class="con_tripinfo ">
            <div class="row ">
                <div class="col-lg-3 col-md-6 con_trripsection con_trripsection1 ">

                    <div>
                        <ngx-skeleton-loader [theme]="{
                  width: '60%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-bottom': '10px'
                }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 con_trripsection con_trripsection2 ">

                    <div>
                        <ngx-skeleton-loader [theme]="{
              width: '60%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px'
            }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 con_trripsection con_trripsection3 ">

                    <div>
                        <ngx-skeleton-loader [theme]="{
                  width: '60%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-bottom': '10px'
                }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 con_trripsection ">

                    <div>
                        <ngx-skeleton-loader [theme]="{
              width: '60%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px'
            }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
            </div>
        </div>
        <div class="con_filghtdetails ">


            <div class="cbot_sec con_secdetailview ">

                <div class="cardheader ">
                    <div class="row ">
                        <div class="col-lg-5 col-md-5 ">

                            <div class="searchul ">
                                <div class="datelist2 m-2 ">
                                    <ngx-skeleton-loader [theme]="{
                                  width: '30%',
                                  'border-radius': '0',
                                  height: '30px',
                                  'margin-bottom': '10px'
                                }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card ">

                    <div class="row ">
                        <div class="col-lg-12 col-md-12 ">
                            <div class=" ">
                                <div class="row ">

                                    <div class="col-lg-2 col-md-12 text-center pr-0 ">
                                        <ngx-skeleton-loader [theme]="{
                                          width: '100%',
                                          'border-radius': '0',
                                          height: '100px',
                                          'margin-bottom': '10px'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="col-lg-10 col-md-12 ">
                                        <div class="d-flex ">
                                            <div class="col-4 pr-0 ">
                                                <div class="c_cityselected ">
                                                    <ngx-skeleton-loader count="2" [theme]="{
                                                  width: '60%',
                                                  'border-radius': '0',
                                                  height: '15px',
                                                  'margin-bottom': '10px'
                                                }">
                                                    </ngx-skeleton-loader>
                                                </div>

                                            </div>
                                            <div class="col-3 text-center pl-0 pr-0 ">

                                                <div class=" plm-10 pr-0 ">
                                                    <div class="c_time ">
                                                        <ngx-skeleton-loader count="2" [theme]="{
                                                          width: '60%',
                                                          'border-radius': '0',
                                                          height: '15px',
                                                          'margin-bottom': '10px'
                                                        }">
                                                        </ngx-skeleton-loader>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-5 pr-0 ">
                                                <div class="c_cityselected ">
                                                    <ngx-skeleton-loader count="2" [theme]="{
                                                  width: '60%',
                                                  'border-radius': '0',
                                                  height: '15px',
                                                  'margin-bottom': '10px'
                                                }">
                                                    </ngx-skeleton-loader>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col-lg-12 col-md-12 text-left pr-0 ">
                                        <span class="company_name ">
                                      <b> <ngx-skeleton-loader [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                                </ngx-skeleton-loader></b>
                                  </span>

                                        <span class="operator ">  <ngx-skeleton-loader  [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                                </ngx-skeleton-loader></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>





                </div>

                <div class="cardheader ">
                    <div class="row ">
                        <div class="col-lg-5 col-md-5 ">
                            <div class="searchul ">
                                <div class="datelist2 m-2 ">

                                    <ngx-skeleton-loader [theme]="{
                                      width: '30%',
                                      'border-radius': '0',
                                      height: '30px',
                                      'margin-bottom': '10px'
                                    }">
                                    </ngx-skeleton-loader>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card ">

                    <div class="row ">
                        <div class="col-lg-12 col-md-12 ">
                            <div class=" ">
                                <div class="row ">

                                    <div class="col-lg-2 col-md-12 text-center pr-0 ">
                                        <ngx-skeleton-loader [theme]="{
                                          width: '100%',
                                          'border-radius': '0',
                                          height: '100px',
                                          'margin-bottom': '10px'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="col-lg-10 col-md-12 ">
                                        <div class="d-flex ">
                                            <div class="col-4 pr-0 ">
                                                <div class="c_cityselected ">
                                                    <ngx-skeleton-loader count="2" [theme]="{
                                                  width: '60%',
                                                  'border-radius': '0',
                                                  height: '15px',
                                                  'margin-bottom': '10px'
                                                }">
                                                    </ngx-skeleton-loader>
                                                </div>

                                            </div>
                                            <div class="col-3 text-center pl-0 pr-0 ">

                                                <div class=" plm-10 pr-0 ">
                                                    <div class="c_time ">
                                                        <ngx-skeleton-loader count="2" [theme]="{
                                                          width: '60%',
                                                          'border-radius': '0',
                                                          height: '15px',
                                                          'margin-bottom': '10px'
                                                        }">
                                                        </ngx-skeleton-loader>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-5 pr-0 ">
                                                <div class="c_cityselected ">
                                                    <ngx-skeleton-loader count="2" [theme]="{
                                                  width: '60%',
                                                  'border-radius': '0',
                                                  height: '15px',
                                                  'margin-bottom': '10px'
                                                }">
                                                    </ngx-skeleton-loader>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col-lg-12 col-md-12 text-left pr-0 ">
                                        <span class="company_name ">
                                      <b> <ngx-skeleton-loader [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                                </ngx-skeleton-loader></b>
                                  </span>

                                        <span class="operator ">  <ngx-skeleton-loader  [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                                </ngx-skeleton-loader></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="con_filghtdetails con_flighttabs ">
            <div class="con_header ">
                <ngx-skeleton-loader [theme]="{
                  width: '30%',
                  'border-radius': '0',
                  height: '30px',
                  'margin-bottom': '10px'
                }">
                </ngx-skeleton-loader>
            </div>
            <div class=" flighttable">

                <div class="col-lg-12 col-md-12 ">

                    <div class="row mt-3">

                        <div class="col-lg-2 col-md-12 text-center pr-0 ">
                            <ngx-skeleton-loader [theme]="{
                                  width: '60%',
                                  'border-radius': '0',
                                  height: '15px',
                                  'margin-bottom': '10px'
                                }">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-lg-10 col-md-12 ">
                            <div class="d-flex ">
                                <div class="col-4 pr-0 ">
                                    <div class="c_cityselected ">
                                        <ngx-skeleton-loader count="2" [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                </div>
                                <div class="col-3 text-center pl-0 pr-0 ">

                                    <div class=" plm-10 pr-0 ">
                                        <div class="c_time ">
                                            <ngx-skeleton-loader count="2" [theme]="{
                                                  width: '60%',
                                                  'border-radius': '0',
                                                  height: '15px',
                                                  'margin-bottom': '10px'
                                                }">
                                            </ngx-skeleton-loader>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-5 pr-0 ">
                                    <div class="c_cityselected ">
                                        <ngx-skeleton-loader count="2" [theme]="{
                                          width: '60%',
                                          'border-radius': '0',
                                          height: '15px',
                                          'margin-bottom': '10px'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="modal fade show" id="loader-3" style="display: block" *ngIf="isLoading">
    <div class="modal-dialog carpayspinner">
        <div class="modal-content">
            <div class="modal-body">
                <div class="col-md-12 text-center pb-20 pt-20">
                    <img src="assets/images/ico/loader-7.gif" width="110px" />
                    <p class="mt-20 opensans font20 font600">
                        Please wait, your booking is in process.. this may take some time
                    </p>
                </div>
            </div>
        </div>
    </div>

</div> -->